import { useMemo } from 'react'
import { CommentReaction } from 'types'
import cx from 'classnames'
import Styles from './ReactionButton.module.scss'
import { useAuth } from 'hooks/UseAuth'
import { Tooltip } from 'components/Tooltip/Tooltip'
import { sortBy } from 'lodash'

interface Props {
  emoji: string
  reactions: CommentReaction[]
  className?: string
  onClick?: () => void
}

export const ReactionButton = ({ reactions, emoji, className, onClick }: Props) => {
  const auth = useAuth()
  const authId = auth?.id

  const active = useMemo(() => {
    return reactions.some((reaction) => reaction.user_id === authId)
  }, [reactions, authId])

  const namesList = useMemo(() => {
    const reactionsSortedByYou = sortBy(reactions, (r) => r.user_id !== authId)
    return reactionsSortedByYou
      .map((reaction) => {
        if (reaction.user_id === authId) {
          return 'You'
        }
        return reaction.user_name
      })
      .reduce((a, b, i, array) => a + (i < array.length - 1 ? ', ' : ' and ') + b)
  }, [reactions, authId])

  return (
    <Tooltip label={`${namesList} reacted with ${emoji}`} placement="top">
      <button className={cx(Styles.container, { [Styles.active]: active }, className)} onClick={onClick} tabIndex={-1}>
        <span className={Styles.emoji}>{emoji}</span>
        <span className={Styles.count}>{reactions.length}</span>
      </button>
    </Tooltip>
  )
}
